import { render, staticRenderFns } from "./BookkeepingSetup.vue?vue&type=template&id=e941de94&"
import script from "./BookkeepingSetup.vue?vue&type=script&lang=ts&"
export * from "./BookkeepingSetup.vue?vue&type=script&lang=ts&"
import style0 from "./BookkeepingSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports